import type { NexusHandler } from "@otto-ec/global-resources/nexus";
import {type ThirdpartyTracking} from "../index.js";
import type { SmartBannerInfo } from "./smartBannerInfo.js";
import {runningInApp} from "../../global/detectionFunctions.js";
import {osMajorVersionAndroid, osMajorVersionIos} from "../../helper/helper.js";

export const shouldDisplaySmartAppBannerWithTracking: NexusHandler<ThirdpartyTracking["shouldDisplaySmartAppBannerWithTracking"]> = function (): SmartBannerInfo {
    const MIN_ANDROID_VERSION = 6;
    const MIN_IOS_VERSION = 13;
    const ADJUST_LINK = "https:/*                                                                                                                                                                                                        */

    const iosOsVersion = osMajorVersionIos();
    const androidOsVersion = osMajorVersionAndroid();

    const isSupportedDevice =
        (androidOsVersion ?? -1) >= MIN_ANDROID_VERSION ||
        (iosOsVersion ?? -1) >= MIN_IOS_VERSION;

    return {
        adjustLink: new URL(ADJUST_LINK),
        shouldDisplaySmartBanner: !runningInApp() && isSupportedDevice,
    };
}
